import DOMPurify from 'dompurify'

/**
 * Escapes text for insertion into HTML (element content and quoted attributes).
 * Use for every value that comes from users, bot subscribers or the API before it is
 * concatenated into a string rendered with v-html / innerHTML.
 */
export function escapeHtml(value) {
  if (value === null || value === undefined) return ''
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

// Tags Telegram / MAX formatting can produce (parse_mode=HTML, rich messages) — everything else
// is dropped. Attributes limited to what the previews need.
const MESSAGE_TAGS = [
  'b', 'strong', 'i', 'em', 'u', 'ins', 's', 'strike', 'del', 'span', 'a', 'code', 'pre',
  'blockquote', 'tg-spoiler', 'tg-emoji', 'br', 'p', 'div', 'ul', 'ol', 'li', 'h1', 'h2', 'h3',
  'h4', 'figure', 'figcaption', 'img', 'video', 'tg-map', 'tg-time', 'hr', 'table', 'thead',
  'tbody', 'tr', 'td', 'th', 'details', 'summary', 'mark', 'sub', 'sup',
]
const MESSAGE_ATTRS = [
  'href', 'class', 'expandable', 'emoji-id', 'src', 'alt', 'lat', 'long', 'zoom', 'unix', 'format',
  'colspan', 'rowspan', 'open', 'data-entity-type',
]

/**
 * Sanitizes message HTML for previews: allowlisted formatting tags only, no event handlers,
 * links limited to http(s)/tg/mailto. Message text is authored by customers (also via API/MCP)
 * and the previews are opened by admins/support, so this must wrap every v-html of message text.
 */
export function sanitizeMessageHtml(html) {
  if (html === null || html === undefined) return ''
  return DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS: MESSAGE_TAGS,
    ALLOWED_ATTR: MESSAGE_ATTRS,
    ALLOWED_URI_REGEXP: /^(?:https?:|tg:|mailto:|#)/i,
    CUSTOM_ELEMENT_HANDLING: {
      tagNameCheck: /^tg-(spoiler|emoji|map|time)$/,
      attributeNameCheck: /^(emoji-id|lat|long|zoom|unix|format)$/,
      allowCustomizedBuiltInElements: false,
    },
  })
}
